/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

// ---------------------------------------------------------------------------
// Nube: the custom blocks (nube-tiers, nube-duo-offer) post to /cart/add.js
// with one entry per pillow, so a pair of identical pillows is sent as two
// items with the same variant id. Shopify's own storefront listener compares
// that payload with the response (one merged line) and gives up with
// "Payload body and response have different number of items", so the
// product_added_to_cart event never reaches the Meta pixel (no AddToCart).
// Merging identical lines before the request keeps payload and response
// consistent. The cart content is exactly the same.
// ---------------------------------------------------------------------------
(function nubeMergeCartAddLines() {
  if (window.__nubeCartMerge) return;
  window.__nubeCartMerge = true;

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
        var parsed = JSON.parse(init.body);
        if (parsed && Array.isArray(parsed.items) && parsed.items.length > 1) {
          var merged = [];
          var index = {};
          parsed.items.forEach(function (item) {
            var key = [item.id, JSON.stringify(item.properties || {}), item.selling_plan || ''].join('|');
            var qty = Number(item.quantity) || 1;
            if (index[key] === undefined) {
              index[key] = merged.length;
              merged.push(Object.assign({}, item, { quantity: qty }));
            } else {
              merged[index[key]].quantity += qty;
            }
          });
          if (merged.length !== parsed.items.length) {
            parsed.items = merged;
            init = Object.assign({}, init, { body: JSON.stringify(parsed) });
          }
        }
      }
    } catch (e) {
      /* never block the add to cart */
    }
    return nativeFetch.call(window, input, init);
  };
})();
